"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaperLessBillDetailsPanelCms = void 0;
var PaperLessBillDetailsPanelCms = /** @class */ (function () {
    function PaperLessBillDetailsPanelCms() {
        this.sectionTitleLabel = 'Paperless billing';
        this.paperlessConsentLabel = 'Want to sign up for paperless billing?';
        this.signUpCheckboxLabel = 'Sign me up for paperless billing';
        this.noThanksRadioLabel = 'No, thanks';
        this.noThanksDesciptionCombinationLabelOne = "Don't miss out! Sign up today, or you won't qualify for the $";
        this.noThanksDesciptionCombinationLabelTwo = "/mo. discount.";
        this.emailConsentdescriptionLabel = "Keep an eye on your inbox. Use the link in the email we send\n     you to verify your email address, and you're done!";
        this.emailConsentdescriptionLabelSMB = "We\u2019ll send you an email. Use the link in the email\n     to verify your email address.";
        this.paperLessTermsLinkLabel = "Read the Paperless Billing Disclosures";
        this.paperLessTermsConsentLabel = "I have read and agree to the Paperless Billing Disclosures.";
        this.paperlessSettingsFromMyAttContent = "We'll set you up with paperless billing--a convenient,secure,and tree-friendly way to view your bills online. You can manage this setting anytime at att.com/myatt.";
        this.paperlessBillingContentAskingForConfirmation = "<strong>Heads up:</strong> Expect an email after you place your order. We'll ask you to confirm the email address we'll use for paperless billing.";
    }
    return PaperLessBillDetailsPanelCms;
}());
exports.PaperLessBillDetailsPanelCms = PaperLessBillDetailsPanelCms;
//# sourceMappingURL=PaperLessBillDetailsPanelCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/PaperLessBillDetailsPanel/PaperLessBillDetailsPanelCms.cms.js
// module id = 2035
// module chunks = 8